var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22 9.28889H14.6667V2H9.28889V9.28889H2V14.6667H9.28889V22H14.6667V14.6667H22V9.28889Z","fill":"currentColor"}));
}

Plus.defaultProps = {"viewBox":"0 0 24 24","fill":"currentColor"};

module.exports = Plus;

Plus.default = Plus;
